import { LazyAction, LazyModule } from 'owa-bundling';

export const lazyEnsureGroupMailboxData = new LazyAction(
    new LazyModule(
        () => import(/** EnsureGroupMailboxData */ './group-mailbox/ensureGroupMailboxData')
    ),
    m => m.ensureGroupMailboxData
);

export const lazyGetGroupAccountSources = new LazyAction(
    new LazyModule(
        () => import(/** GetGroupAccountSources */ './group-mailbox/getGroupAccountSources')
    ),
    m => m.getGroupAccountSources
);

const lazyAdditionalAccountInfoModule = new LazyModule(
    () => import(/** EnsureAdditionalAccountInfoData */ './additionalAccountInfo')
);

export const lazyEnsureAdditionalAccountInfoData = new LazyAction(
    lazyAdditionalAccountInfoModule,
    m => m.ensureAdditionalAccountInfoData
);

export const lazyEnsureAllAdditionalAccountInfoData = new LazyAction(
    lazyAdditionalAccountInfoModule,
    m => m.ensureAllAdditionalAccountInfoData
);
